import {
  FailableAction,
  failableActionCreator,
  Memoed,
  Action,
  actionCreator,
} from '@library/react-toolkit'

export type State = Memoed<{ balance: Balance; userNymID: string }>

export type Balance = Record<string, number>

export type GetBalanceAction = Action<'BALANCE/get_balance'>
export const getBalanceAction = actionCreator<GetBalanceAction>(
  'BALANCE/get_balance'
)

export type GetBalanceResult = FailableAction<
  'BALANCE/get_balance_result',
  { balance: Balance; userNymID: string }
>
export const getBalanceResult = failableActionCreator<GetBalanceResult>(
  'BALANCE/get_balance_result'
)

export type Actions = GetBalanceAction | GetBalanceResult
